export interface CountryCode {
  Country: String;
  Code: String

}
export const CountryCodes: Array<CountryCode> = [
  { Country: "NG", Code: "+234" },
  { Country: "UK", Code: "+44" },
  { Country: "US", Code: "+1" },
  { Country: "AF", Code: "+93" },
  { Country: "AL", Code: "+355" },
  { Country: "DZ", Code: "+213" },
  { Country: "AD", Code: "+376" },
  { Country: "AO", Code: "+244" },
  { Country: "AG", Code: "+1-268" },
  { Country: "AR", Code: "+54" },
  { Country: "AM", Code: "+374" },
  { Country: "AU", Code: "+61" },
  { Country: "AT", Code: "+43" },
  { Country: "AZ", Code: "+994" },
  { Country: "BS", Code: "+1-242" },
  { Country: "BH", Code: "+973" },
  { Country: "BD", Code: "+880" },
  { Country: "BB", Code: "+1-246" },
  { Country: "BY", Code: "+375" },
  { Country: "BE", Code: "+32" },
  { Country: "BZ", Code: "+501" },
  { Country: "BJ", Code: "+229" },
  { Country: "BT", Code: "+975" },
  { Country: "BO", Code: "+591" },
  { Country: "BA", Code: "+387" },
  { Country: "BW", Code: "+267" },
  { Country: "BR", Code: "+55" },
  { Country: "BN", Code: "+673" },
  { Country: "BG", Code: "+359" },
  { Country: "BF", Code: "+226" },
  { Country: "BI", Code: "+257" },
  { Country: "CV", Code: "+238" },
  { Country: "KH", Code: "+855" },
  { Country: "CM", Code: "+237" },
  { Country: "CA", Code: "+1" },
  { Country: "CF", Code: "+236" },
  { Country: "TD", Code: "+235" },
  { Country: "CL", Code: "+56" },
  { Country: "CN", Code: "+86" },
  { Country: "CO", Code: "+57" },
  { Country: "KM", Code: "+269" },
  { Country: "CG", Code: "+242" },
  { Country: "CD", Code: "+243" },
  { Country: "CR", Code: "+506" },
  { Country: "HR", Code: "+385" },
  { Country: "CU", Code: "+53" },
  { Country: "CY", Code: "+357" },
  { Country: "CZ", Code: "+420" },
  { Country: "DK", Code: "+45" },
  { Country: "DJ", Code: "+253" },
  { Country: "DM", Code: "+1-767" },
  { Country: "DO", Code: "+1-809" },
  { Country: "EC", Code: "+593" },
  { Country: "EG", Code: "+20" },
  { Country: "SV", Code: "+503" },
  { Country: "GQ", Code: "+240" },
  { Country: "ER", Code: "+291" },
  { Country: "EE", Code: "+372" },
  { Country: "SZ", Code: "+268" },
  { Country: "ET", Code: "+251" },
  { Country: "FJ", Code: "+679" },
  { Country: "FI", Code: "+358" },
  { Country: "FR", Code: "+33" },
  { Country: "GA", Code: "+241" },
  { Country: "GM", Code: "+220" },
  { Country: "GE", Code: "+995" },
  { Country: "DE", Code: "+49" },
  { Country: "GH", Code: "+233" },
  { Country: "GR", Code: "+30" },
  { Country: "GD", Code: "+1-473" },
  { Country: "GT", Code: "+502" },
  { Country: "GN", Code: "+224" },
  { Country: "GW", Code: "+245" },
  { Country: "GY", Code: "+592" },
  { Country: "HT", Code: "+509" },
  { Country: "HN", Code: "+504" },
  { Country: "HU", Code: "+36" },
  { Country: "IS", Code: "+354" },
  { Country: "IN", Code: "+91" },
  { Country: "ID", Code: "+62" },
  { Country: "IR", Code: "+98" },
  { Country: "IQ", Code: "+964" },
  { Country: "IE", Code: "+353" },
  { Country: "IL", Code: "+972" },
  { Country: "IT", Code: "+39" },
  { Country: "JM", Code: "+1-876" },
  { Country: "JP", Code: "+81" },
  { Country: "JO", Code: "+962" },
  { Country: "KZ", Code: "+7" },
  { Country: "KE", Code: "+254" },
  { Country: "KI", Code: "+686" },
  { Country: "KW", Code: "+965" },
  { Country: "KG", Code: "+996" },
  { Country: "LA", Code: "+856" },
  { Country: "LV", Code: "+371" },
  { Country: "LB", Code: "+961" },
  { Country: "LS", Code: "+266" },
  { Country: "LR", Code: "+231" },
  { Country: "LY", Code: "+218" },
  { Country: "LI", Code: "+423" },
  { Country: "LT", Code: "+370" },
  { Country: "LU", Code: "+352" },
  { Country: "MG", Code: "+261" },
  { Country: "MW", Code: "+265" },
  { Country: "MY", Code: "+60" },
  { Country: "MV", Code: "+960" },
  { Country: "ML", Code: "+223" },
  { Country: "MT", Code: "+356" },
  { Country: "MH", Code: "+692" },
  { Country: "MR", Code: "+222" },
  { Country: "MU", Code: "+230" },
  { Country: "MX", Code: "+52" },
  { Country: "FM", Code: "+691" },
  { Country: "MD", Code: "+373" },
  { Country: "MC", Code: "+377" },
  { Country: "MN", Code: "+976" },
  { Country: "ME", Code: "+382" },
  { Country: "MA", Code: "+212" },
  { Country: "MZ", Code: "+258" },
  { Country: "MM", Code: "+95" },
  { Country: "NA", Code: "+264" },
  { Country: "NR", Code: "+674" },
  { Country: "NP", Code: "+977" },
  { Country: "NL", Code: "+31" },
  { Country: "NZ", Code: "+64" },
  { Country: "NI", Code: "+505" },
  { Country: "NE", Code: "+227" },
  { Country: "MK", Code: "+389" },
  { Country: "NO", Code: "+47" },
  { Country: "OM", Code: "+968" },
  { Country: "PK", Code: "+92" },
  { Country: "PW", Code: "+680" },
  { Country: "PS", Code: "+970" },
  { Country: "PA", Code: "+507" },
  { Country: "PG", Code: "+675" },
  { Country: "PY", Code: "+595" },
  { Country: "PE", Code: "+51" },
  { Country: "PH", Code: "+63" },
  { Country: "PL", Code: "+48" },
  { Country: "PT", Code: "+351" },
  { Country: "QA", Code: "+974" },
  { Country: "RO", Code: "+40" },
  { Country: "RU", Code: "+7" },
  { Country: "RW", Code: "+250" },
  { Country: "KN", Code: "+1-869" },
  { Country: "LC", Code: "+1-758" },
  { Country: "VC", Code: "+1-784" },
  { Country: "WS", Code: "+685" },
  { Country: "SM", Code: "+378" },
  { Country: "ST", Code: "+239" },
  { Country: "SA", Code: "+966" },
  { Country: "SN", Code: "+221" },
  { Country: "RS", Code: "+381" },
  { Country: "SC", Code: "+248" },
  { Country: "SL", Code: "+232" },
  { Country: "SG", Code: "+65" },
  { Country: "SK", Code: "+421" },
  { Country: "SI", Code: "+386" },
  { Country: "SB", Code: "+677" },
  { Country: "SO", Code: "+252" },
  { Country: "ZA", Code: "+27" },
  { Country: "KR", Code: "+82" },
  { Country: "SS", Code: "+211" },
  { Country: "ES", Code: "+34" },
  { Country: "LK", Code: "+94" },
  { Country: "SD", Code: "+249" },
  { Country: "SR", Code: "+597" },
  { Country: "SE", Code: "+46" },
  { Country: "CH", Code: "+41" },
  { Country: "SY", Code: "+963" },
  { Country: "TW", Code: "+886" },
  { Country: "TJ", Code: "+992" },
  { Country: "TZ", Code: "+255" },
  { Country: "TH", Code: "+66" },
  { Country: "TL", Code: "+670" },
  { Country: "TG", Code: "+228" },
  { Country: "TO", Code: "+676" },
  { Country: "TT", Code: "+1-868" },
  { Country: "TN", Code: "+216" },
  { Country: "TR", Code: "+90" },
  { Country: "TM", Code: "+993" },
  { Country: "TV", Code: "+688" },
  { Country: "UG", Code: "+256" },
  { Country: "UA", Code: "+380" },
  { Country: "AE", Code: "+971" },
  { Country: "UY", Code: "+598" },
  { Country: "UZ", Code: "+998" },
  { Country: "VU", Code: "+678" },
  { Country: "VA", Code: "+39-06" },
  { Country: "VE", Code: "+58" },
  { Country: "VN", Code: "+84" },
  { Country: "YE", Code: "+967" },
  { Country: "ZM", Code: "+260" },
  { Country: "ZW", Code: "+263" }
]